import React, { StrictMode, useEffect, useState } from "react";
import toast from "react-hot-toast";
import useContactAttributes from "../../hooks/useContactAttributes";
// Hooks
import useContactEvents from "../../hooks/useContactEvents";
import useCreditCardDetails from "../../hooks/useCreditCardDetails";
import useCurrentContact from "../../hooks/useCurrentContact";
import useRecordButton from "../../hooks/useRecordButton";
import { SITE_MAP_ENUM } from "../../utility/util";
import "./App.css";
// Providers
import { useAppConfig } from "../../providers/AppConfigProvider";
import { getCannedMsgAPI } from "../../services/cannedMsg";
import storeQueueDetails from "../../services/queueDetails";
import CannedResponse from "../CannedResponse/CannedResponse";
import CustomRag from "../CustomRag/CustomRag";
import AgentAssist from "../agentAssist/agentAssist";

import ContactDetails from "../ContactDetails/ContactDetails";
import CreditCardDetails from "../CreditCardDetails/CreditCardDetails";
import IVRCrumbs from "../IVRCrumbs/IVRCrumbs";
import MessageLog from "../MessageLog/MessageLog";

// Components
import Recording from "../Recording/Recording";
import MultipleModules from "../TabbedModules/TabbedModules";
import ToastComponent from "../ToastComponent/ToastComponent";
import "./App.css";

import { EventEmitter } from "../../utility/events";
import Miscellaneous from "../Miscellaneous/Miscellaneous";
import UserActivity from "../UserActivity/UserActivity";
import AppWebSocketComp from "../AppWebSocketComp";

const App = () => {
  console.log("App loaded");
  let [clientType, setClientType] = useState("");
  const [agentType, setAgentType] = useState("voice");
  const attributePack = useContactAttributes();
  const contactEvents = useContactEvents();
  const contactData = useCurrentContact();
  const [agentStatus, setAgentStatus] = useState(null);

  const {
    updateSelectContact,
    updateCannedMsgSet,
    agentLdap,
    routingProfile,
    updateWsConnection,
    wsConn,
    updateContactList,
    updateSelectInitialContact,
    routingValue,
    passTranscript,
    updateSetPassTranscript,
    selectContact,
    cannedMsgSet: hookCannedMsgSet,
  } = useAppConfig();

  let cannedMsgSet = new Set();
  function checkContactsAndShut() {
    return new Promise((resolve) => {
      window.connect.agent(function (agent) {
        let chatContacts = agent.getContacts(window.connect.ContactType.CHAT);
        // updateContactList(chatContacts)
        resolve(chatContacts);
      });
    });
  }
  const loadCannedMessages = () => {
    return new Promise((resolve) => {
      const promises = SITE_MAP_ENUM.map((item) => {
        return getCannedMsgAPI(item.site);
      });

      Promise.all(promises).then((results) => {
        for (let index = 0; index < results.length; index++) {
          const element = results[index];
          let config = JSON.parse(element.config.data);
          if (element.status == 200 && element.data.data.length > 0) {
            let tempResult = element.data.data;
            for (var i in tempResult) {
              tempResult[i].edit = false;
              tempResult[i].loading = false;
            }
            cannedMsgSet[config.site] = tempResult;
            updateCannedMsgSet({ ...cannedMsgSet });
            // setCannedMsgSet({...cannedMsgSet})
          }
        }
        toast.success("All canned message loaded");
        resolve(true);
      });
    });
  };

  function callAccepted(contact) {
    let type = contact.getType();
    setClientType(type);

    if (type !== "chat") {
      // hideCannedMessage(type)
    } else {
      // showCannedMessage(type)
    }
  }

  useEffect(() => {
    window.connect.core.onViewContact(function (event) {
      checkContactsAndShut()
        .then(async (contacts) => {
          if (event && event.contactId) {
            let currentContact = contacts.filter(
              (val) => val.contactId === event.contactId
            );
            if (currentContact.length > 0) {
              if (currentContact[0].isConnected() === true) {
                let responseKeys = Object.keys(cannedMsgSet);
                if (responseKeys.length == 0) {
                  loadCannedMessages();
                }
                contactData.setContacts(currentContact[0]);
                callAccepted(currentContact[0]);
              } else {
                contactData.deleteContact(currentContact[0]);
              }
            }
            updateSelectContact(event.contactId);
            updateSelectInitialContact(
              currentContact[0].getOriginalContactId()
                ? currentContact[0].getOriginalContactId()
                : currentContact[0].getContactId()
            );
          } else {
            contactData.deleteContact(contacts[0]);
            sessionStorage.removeItem("activeChat");
            updateSelectContact(null);
            updateSelectInitialContact(null);
          }
        })
        .catch((err) => {
          console.error("checkContactsAndShut", err);
        });
    });

    window.connect.contact(function (contact) {
      contact.onAccepted(async function () {
        let responseKeys = Object.keys(cannedMsgSet);
        if (responseKeys.length == 0) {
          await loadCannedMessages();
        }
        callAccepted(contact);
        EventEmitter.dispatch("CONTACT_ACCEPTED", contact);
      });
      contact.onEnded(function () {
        EventEmitter.dispatch("CONTACT_REMOVE", contact);
      });

      contact.onDestroy(function () {
        EventEmitter.dispatch("CONTACT_REMOVE", contact);
      });
    });
  }, []);
  useEffect(() => {
    const contactsForChat = window.connect.contact(function (contact) {
      const attributes = contact.getAttributes();
      const queue = contact.getQueue();
      const queueDetails = [
        {
          InitialContactId: attributes.initialContactId.value,
          contactID: contact.getContactId(),
          queueName: attributes.queueName.value,
          queue: queue.name,
          agent: agentLdap,
          routingProfile: routingProfile.name,
        },
      ];
      if (contact.getType() === "chat") {
        storeQueueDetails(queueDetails);
      }
    });

    const agentSubscription = window.connect.agent(function (agent) {
      console.log("In agentSubscription");
      const agentName = agent.getName();
      const agentDetails = agent.getChannelConcurrency();
      console.log("In agentSubscription", agentDetails);
      if ("CHAT" in agentDetails && agentDetails.CHAT > 0) {
        setAgentType("chat");
        loadCannedMessages();
        document
          .getElementById("iframeCCP")
          .classList.replace("col-6", "col-4");
        document
          .getElementById("CCP-Modules")
          .classList.replace("col-6", "col-8");
        document
          .getElementById("multiple-modules")
          .classList.replace("multiple-modules-ivr", "multiple-modules-chat");
      }
      console.log("agentDetails", agentDetails);

      agent.onStateChange(function (agentStateChange) {
        console.log("agentStateChanged", agentStateChange);
        setAgentStatus(agentStateChange.agent.getStatus().name);
      });
    });

    return () => {
      contactsForChat.unsubscribe();
      agentSubscription.unsubscribe();
    };
  }, []);

  const recordingDetails = useRecordButton(contactData);
  const creditCardDetails = useCreditCardDetails(contactData);
  const modules = [
    {
      title: "Message Log",
      module: <MessageLog contactEvents={contactEvents} />,
    },
    {
      title: "Recording",
      module: <Recording recordingDetails={recordingDetails} />,
    },
    {
      title: "Payment Details",
      module: <CreditCardDetails creditCardDetails={creditCardDetails} />,
    },
    {
      title: "IVR Crumbs",
      module: <IVRCrumbs attributePack={attributePack} />,
    },
  ];
  // resizeing blocks if AmazonQ is activate
  useEffect(() => {
    if (agentType == "voice" && routingValue == "true") {
      // document.getElementById("iframeCCP").classList.replace("col-6", "col-4");
      document
        .getElementById("multiple-modules")
        .classList.replace("multiple-modules-ivr", "multiple-modules-Q");
    }
  }, []);
  return (
    <>
      <div className={"row content-height"}>
        {agentType === "chat" && (
          <div className={"col-6"}>
            <CannedResponse contactSet={contactData.contactSet || undefined} />
          </div>
        )}

        <div className={agentType === "voice" ? "col content-height" : "col-6"}>
          <ContactDetails
            contactSet={contactData.contactSet || undefined}
            className="h-100"
          />
        </div>

        {/* {routingValue == "true" && (
          <div className={agentType === "voice" ? "col-6" : "col-4"}>
            <AgentAssist contactSet={contactData.contactSet || undefined} />
          </div>
        )} */}
      </div>

      {/* Websocket component */}
      {agentType === "chat" && (
        <div className={"container-fluid chat-common-module-1"}>
          <div className="row">
            <div className="col-12">
              <AppWebSocketComp agentStatus={agentStatus} />
            </div>
          </div>
        </div>
      )}

      {/* Multiple Modules component */}
      {agentType === "voice" && (
        <div className="row multiple-modules-ivr mt-5" id="multiple-modules">
          <MultipleModules className="message-log-module" tabs={modules} />
        </div>
      )}

      {/* Toast Component Loading */}
      <ToastComponent />
    </>
  );
};

export default App;
